<template>
	<div class="appContainer">
		<div class="container" :class="{isFlash: boleto.flash == '1', isExpress: boleto.flash != '1'}">
			<div>
				<div class="div_img bg-gray py-4" v-if="!show_loading && !hideHeaderAndFooter">
					<div class="text-left w-50 pl-4 py-2" v-if="(boleto_permitido.length == 1 && boleto_permitido[0] == 'PIX')">
						<img class="logo-pagbrasil mt-2" src="~@/assets/img/logos/pagbrasil.svg">
					</div>
					<div class="w-100" v-else>
						<div class="text-left w-50 pl-4 py-2" v-if="hasLogo()">
							<img :src="'data:image/svg+xml;base64,' + boleto.logo" style="border: none; max-width: 170px; max-height:35px;" v-if="boleto.logo_boleto_ext == 'SVG'">
							<img :src="'data:image/png;base64,' + boleto.logo" style="border: none;" v-else>
						</div>

						<div class="py-2" :class="{'w-50 text-right pr-4': hasLogo(), 'w-100 text-center': !hasLogo()}">
							<img v-if="boleto.flash != '1'" class="img_boleto_pb_express" src="~@/assets/img/logos/pagbrasil.svg" >
							<a v-if="boleto.flash == '1'" href="https://boletoflash.com/" target="_blank">
								<img class="img_boleto_flash" src="~@/assets/img/logos/boleto_flash.svg" >
							</a>
						</div>
					</div>
				</div>
				<div class="divMobile p-0 mx-0 mb-4 w-100 noprint" v-if="boleto.flash == '1' && !clicklocal">

					<div class="text-center text-lh-1 msgInstrucao my-4" v-if="!clicklocal">
						<div class="py-2 mt-2">
							<span>Selecione o banco</span><br>onde você irá pagar o boleto:
						</div>
					</div>

					<div v-for="item in listaBanco"
						:key="item"
						v-if="boletoAtivo(item) && (!clicklocal || (opt == item && !opt_outro && !opt_pix))"
						class="bankOption px-3">

						<div v-show="!clicklocal" @click="selecionaBanco(item)">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/bb.svg"			v-if="item == '001'">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/caixa.svg"			v-if="item == '104'">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/itau.svg"			v-if="item == '341'">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/bradesco.svg"		v-if="item == '237'">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/santander.svg"	v-if="item == '033'">
							<span class="ml-3">{{descricaoBanco(item)}}</span>
							<div class="setaBanco">&nbsp;</div>
						</div>
					</div>

					<div
						v-if="(!clicklocal || opt_outro) && !(boleto_permitido.length == 1 && boleto_permitido[0] == 'PIX')"
						class="bankOption px-3">
						<div v-show="!clicklocal" @click="selecionaBanco('')">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/others.svg">
							<span class="ml-3">Outros</span>
							<div class="setaBanco">&nbsp;</div>
						</div>
					</div>

					<div v-if="boletoAtivo('PIX') && (!clicklocal || opt_pix)" class="bankOption px-3">
						<div v-show="!clicklocal" @click="selecionaBanco('PIX')">
							<img class="my-3 ml-3" src="~@/assets/img/brands/icons/pix.svg">
							<span class="ml-3">Pague com Pix</span>
							<div class="setaBanco">&nbsp;</div>
						</div>
					</div>
				</div>

				<div class="divMobile info_pedido px-3 pb-3 pt-4 w-100" v-if="try_register[opt] && opt != 'PIX'">

					<div class="resumoPedido">
						<div class="px-3 my-1">
							<label for="num_pedido">Nº do Pedido:</label>
							<span id="num_pedido">{{boleto.order}}</span>
						</div>

						<div class="px-3 my-1">
							<label for="vencimento">Vencimento:</label>
							<span id="vencimento" class="notranslate">{{$helper.formatDate(boleto.data_vencimento)}}</span>
						</div>

						<div class="px-3 my-1">
							<label for="valor">Valor:</label>
							<span id="valor">R$ {{$helper.formatValue(boleto.valor)}}</span>
						</div>
					</div>

					<div class="linha_dig mt-4">
						<label class="clique-codigo text-center w-100 d-inline-block" for="linha_dig">
							Clique para copiar o código de barras:
						</label>
						<div>
							<textarea readonly="true" id="linha_dig" class="mt-1 p-3 mx-0" v-model="linha_digitavel" @click="seleciona_linhadig" @blur="fecha_tag"></textarea>
						</div>
						<div id="tagCopied" class="tagCopied">
							<div class="arrowUp"></div>
							<div class="popover-body">copiado!</div>
						</div>
					</div>

					<div class="codigo_barras">

						<div id="codigo_barras_small" class="mt-3">
							<img class="icon_rotate mr-1" src="~@/assets/img/pbi/pbi_rotacionar.svg">
							Rotacione para ver o código de barras
						</div>

						<div id="codigo_barras_full">
							<img :src="barcode_aux" v-if="refresh">
						</div>
					</div>

				</div>

				<div class="divMobile w-100 px-3 pb-3 pt-4 bg-gray" v-if="opt == 'PIX'">
					<PaymentMethodPixMobile />
				</div>

				<div class="hr my-2" v-if="try_register[opt]">&nbsp;</div>

				<div class="divMobile rodape px-3 py-3 pb-4 text-center" v-if="!show_loading && !hideHeaderAndFooter">
					<div class="duvidas mt-0 mb-4 pb-1 text-left">
						<span v-html="boleto.texto_boleto"></span>
					</div>
					<a href="https://pagbrasil.com" target="_blank" class="no_decoration">
						{{ onlyPix ? 'Pagamento' : 'Boleto' }} processado pela <b>PagBrasil</b>
					</a>
				</div>

				<div class="bx-b-completo px-3 noprint" :class="{'bx-float': opcao_clicada && !forceMobile}" v-if="try_register[opt] && opt != 'PIX'">
					<div class="text-center boleto_completo mx-0 my-2 p-3" @click="exibeCompleto">
						CLIQUE PARA VER O BOLETO COMPLETO
					</div>
				</div>

				<div class="bx-float-space py-3 my-2" v-if="opcao_clicada && !forceMobile">&nbsp;</div>
			</div>

		</div>

		<Loader />
	</div>
</template>

<script>
	import PaymentMethodPixMobile from '@/components/PaymentMethodPixMobile.vue'
	import Loader from '@/components/Loader.vue'

	import { mapActions, mapState, mapMutations } from 'vuex'

	export default {
		name: 'BoletoMobileA',

		components: {
			PaymentMethodPixMobile,
			Loader
		},

		data(){
			return {
				refresh: false,
				"linha_teste": "0000000000 00000000000 00000000000 0 00000000000000",
				onlyPix: false
			}
		},


		mounted(){

			this.$nextTick(() => {
				this.refreshImg();

				// Se tem apenas o PIX habilitado, já "clica" no pix
				if(this.boleto_permitido.length == 1 && this.boleto_permitido[0] == 'PIX'){
					this.onlyPix = true;
					this.selecionaBanco("PIX");
				}
			});
		},

		computed: {

			show_loading(){
				return this.$store.state.boleto.show_loading;
			},

			boleto(){
				return this.$store.state.boleto.boleto;
			},

			opt(){
				return this.$store.state.boleto.opt;
			},

			boletoA(){
				return this.$store.state.boleto.boletoA;
			},

			boletoB(){
				return this.$store.state.boleto.boletoB;
			},

			opt_outro(){
				return this.$store.state.boleto.opt_outro;
			},

			opt_pix(){
				return this.$store.state.boleto.opt_pix;
			},

			ag_beneficiario(){
				return this.$store.state.boleto.ag_beneficiario;
			},

			boletobanco(){
				return this.$store.state.boleto.boletobanco;
			},

			try_register(){
				return this.$store.state.boleto.try_register;
			},

			opcao_clicada(){
				return this.$store.state.boleto.opcao_clicada;
			},

			boletonotfound(){
				return this.$store.state.boleto.boletonotfound;
			},

			forceMobile(){
				return this.$store.state.boleto.forceMobile;
			},

			hideHeaderAndFooter(){
				return this.$store.state.boleto.hideHeaderAndFooter;
			},

			barcode_aux(){

				var baseUrl = process.env.VUE_APP_BASEURL + ':' + process.env.VUE_APP_BASEURLPORT + "/api/boleto/";
				if(process.env.NODE_ENV != 'development'){
					baseUrl = process.env.VUE_APP_BASEURL;
				}

				let aux = baseUrl + 'getBarcode.php?';
				aux += 'valor=';

				let valor = '00000000000000000000000000000000000000000000';
				if(typeof this.boletobanco.barcode != "undefined"){
					valor = this.boletobanco.barcode;
				}

				let cont = 0;
				for(let i=0; i< valor.length; i++){
					cont += parseInt(valor[i]);
				}

				aux += valor + "_" + cont;

				return aux;
			},

			linha_digitavel(){
				return this.$options.filters.linha_quebra(this.boletobanco.linha_digitavel);
			},

			boleto_permitido(){
				return this.$store.state.boleto.boleto_permitido;
			},

			listaBanco(){
				return this.$store.state.boleto.listaBanco;
			},

			clicklocal(){
				return this.$store.state.boleto.clicklocal;
			},
		},

		methods:{
			...mapActions({
				tryRegistro: 'boleto/tryRegistro'
			}),

			selecionaBanco(banco){
				this.tryRegistro(banco).then(() => {

					//self.$store.commit("boleto/setShowBoletoB", true);

					this.$store.commit("boleto/setClicklocal", true);
					this.$store.commit("boleto/setOpcaoClicada", true);

					this.refreshImg();
				});

				this.$store.commit('boleto/sendPostIframeOptionSelected');
			},

			refreshImg(){
				this.refresh = false;
				window.setTimeout(() => {
					this.refresh = true;
				}, 50);
			},

			seleciona_linhadig(){
				let textarea = document.querySelector("#linha_dig");

				if(navigator.userAgent.match(/ipad|iphone/i)){
					var range, selection;

					range = document.createRange();
					range.selectNodeContents(textarea);
					selection = window.getSelection();
					selection.removeAllRanges();
					selection.addRange(range);
					textarea.setSelectionRange(0, 999999);

				}else{
					textarea.select();
				}

				document.execCommand('copy');

				let aux = document.querySelector("#tagCopied");
				aux.style.display = "block";
			},

			fecha_tag(){
				let aux = document.querySelector("#tagCopied");
				aux.style.display = "none";
			},

			exibeCompleto(){
				window.open(window.location.href + "&desktop=1&brand="+ this.opt);
			},

			boletoAtivo(val){
				if(this.boleto_permitido.indexOf(val) != -1){
					return true;
				}
				return false;
			},

			hasLogo(){
				if(this.boleto.logo != null && this.boleto.logo != ''){
					return true;
				}
				return false;
			},

			descricaoBanco(banco){
				return this.$store.getters["boleto/descricaoBanco"](banco);
			},
		},

		filters:{
			linha_quebra(val){
				if(typeof val == "undefined" || val == ''){
					return '';
				}

				let ret = val.substr(0,5);
				ret += ""; // ponto
				ret += val.substr(5,5);
				ret += " ";
				ret += val.substr(10,5);
				ret += ""; // ponto
				ret += val.substr(15,6);
				ret += " ";
				ret += val.substr(21,5);
				ret += ""; // ponto
				ret += val.substr(26,6);
				ret += " ";
				ret += val.substr(32,1);
				ret += " ";
				ret += val.substr(33);

				return ret;
			}
		}
	}

</script>
